import React, {
  PropsWithChildren,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";
import { BotFormContext } from "@shared/features/bots/BotForm/common/BotForm.context";
import { Steps } from "@shared/features/bots/BotForm/common/types";
import { NoAccountCardHighlightContext } from "features/bots/BotForm/common/NoAccountCardHighlight.context";

const NoAccountCardHighlightProvider = ({ children }: PropsWithChildren) => {
  const { tab, setTab } = useContext(BotFormContext) || {};
  const [highlightCount, setHighlightCount] = useState(0);
  const highlightCard = useCallback(() => {
    if (tab !== Steps.GENERAL) setTab?.(Steps.GENERAL);
    setHighlightCount((count) => count + 1);
  }, [tab, setTab]);
  const value = useMemo(
    () => ({ highlightCount, highlightCard }),
    [highlightCount, highlightCard]
  );
  return (
    <NoAccountCardHighlightContext.Provider value={value}>
      {children}
    </NoAccountCardHighlightContext.Provider>
  );
};

export default NoAccountCardHighlightProvider;
